import KpiMapping from "./KpiMapping";
export default KpiMapping;
